import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { reducer as toastrReducer } from 'react-redux-toastr';
import thunk from 'redux-thunk';
import { reducer as projectEntryReducer } from './ProjectEntry';
import { reducer as prototypeEntryReducer } from './Prototype';
import { reducer as labEntryReducer } from './Lab';
import { reducer as engineeringEntryReducer } from './Engineering';
import { reducer as timeBucketReducer } from './TimeBucket';
import { reducer as userReducer } from './User';
import { reducer as adminEmailsReducer } from './AdminEmails';
import { reducer as projectsReducer } from './Projects';
import { reducer as configReducer } from './Config';
import { reducer as bulkEntryReducer } from './BulkEntry';
import { reducer as notificationsReducer } from './Notification';

export function configureStore(history, initialState) {
  const middleware = [thunk, routerMiddleware(history)];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (
    isDevelopment &&
    typeof window !== 'undefined' &&
    window.devToolsExtension
  ) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    toastr: toastrReducer,
    projectEntry: projectEntryReducer,
    prototypeEntry: prototypeEntryReducer,
    labEntry: labEntryReducer,
    engineeringEntry: engineeringEntryReducer,
    timeBucket: timeBucketReducer,
    user: userReducer,
    adminEmails: adminEmailsReducer,
    projects: projectsReducer,
    config: configReducer,
    router: connectRouter(history),
    bulkEntry: bulkEntryReducer,
    notifications: notificationsReducer
  });

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware), ...enhancers));

  return store
}
